import {createSlice} from "@reduxjs/toolkit";
import {setSettlementPageFilter} from "./actions";
import {startOfMonth, subMonths} from "@ots-frontend/ots-data"

type SettlementPageState = {
  filter: {
    dttm: number
  }
}

const INITIAL_STATE: Readonly<SettlementPageState> = {
  filter: {
    dttm: subMonths(startOfMonth(new Date()), 1).getTime(),
  }
};

const settlementPageSlice = createSlice({
  name: "ui/settlement-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setSettlementPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
  }
});

export const settlementPageReducer = settlementPageSlice.reducer;
